import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

// import plugins if you need
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import img1 from "../../../../assets/Travel partener2.svg"
import { useCallback, useRef, useState } from "react";

const Gallery = (props) => {
  const onInit = () => {
    console.log("lightGallery has been initialized");
  };
 

 
  return (
    <div className="App">
      <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
        {props.images.map((item, index) => (
      
           <a key={index} href={item.image_url}>
            <img
              alt={`photo ${index + 1}`}
              className="gallery"
              src={item.image_url}
            />
          </a>
      
        ))}
      </LightGallery>
        
      
    </div>
  );
};
export default Gallery;
